import jsPDF from "jspdf";
import { FormCreacionUsuario } from "../interfaces/creacionUsuario.interface";
import { UserOptions } from "jspdf-autotable";
import logoFeles from '../media/logos/PNG/ISO_FELES_Supervisor.png'

export const pdfPerfilTableUsuario = (formUser: FormCreacionUsuario):UserOptions => {
  return {
    styles: { fontSize: 8 },
    columnStyles : { 
      0: {fillColor: '#13AD90', textColor: '#FFFFFF', halign: 'center', fontStyle: 'bold', lineWidth: 0.4, lineColor : '#F3F3F3', cellWidth: 35},
    },
    body: [
      [{content: 'Datos del usuario', colSpan: 2, styles: {halign: 'center', valign: 'middle', minCellHeight: 10, fillColor: '#FFFFFF', fontStyle: 'bold', textColor: '#000000'}}],  
      ['Nombres', `${formUser.first_name || ''} ${formUser.second_name || ''} ${formUser.third_name || ''}`.trim()],
      ['Apellidos', `${formUser.last_name || ''} ${formUser.last_name2 || ''} ${formUser.last_name_married || ''}`.trim()],
      ['Teléfono celular', `+${formUser.phone_number || ''}`],
      ['Correo electrónico', `${formUser.email || ''}`],
      ['Dirección', `${formUser.location || ''}`],
      ['Fecha de nacimiento', `${new Date(formUser.birth_date).toLocaleDateString() || ''}`],
      ['Documento de identificación', `${formUser.nombreTipoDocumento || ''}`],
      ['No. documento de identificación', `${formUser.id_number || ''}`],
    ],
    startY: 25,
    margin: { right: 110 },
  };
}

export const pdfPerfilTableEmisor = (formClient: any):UserOptions => {
  return {
    styles : { fontSize: 8 },
    columnStyles : { 0: {fillColor: '#13AD90', textColor: '#FFFFFF', halign: 'center', fontStyle: 'bold', lineWidth: 0.4, lineColor : '#F3F3F3', cellWidth: 35}},
    body: [
      [{content: 'Datos del emisor', colSpan: 2, styles: {halign: 'center', valign: 'middle', minCellHeight: 10, fillColor: '#FFFFFF', fontStyle: 'bold', textColor: '#000000'}}],
      ['Razón social', `${formClient.nombre || ''}`],
      ['NIT', `${formClient.nit || ''}`],
      ['NRC', `${formClient.nrc || ''}`],
      ['Actividad económica', `${formClient.codactividad + ' - ' + formClient.descactividad || ''}`,],
      ['Dirección',`${formClient.complemento || ''}`], 
      ['Tipo de establecimiento', `${formClient.desTipoEstablecimiento || ''}`],
      ['Nombre comercial', `${formClient.nombrecomercial || ''}`],
      ['Departamento', `${formClient.departamentonombre || ''}`],
      ['Municipio', `${formClient?.municipionombre?.charAt(0).toUpperCase() + formClient?.municipionombre?.toLowerCase().slice(1) || ''}`],
      ['Tipo de empresa', `${formClient.desTipoEmpresa || ''}`],
      ['Tipo de contribuyente', `${formClient.desContribuyente || ''}`],
    ],
    startY: 25,
    margin: { left: 110 },
  };
}

export const pdfPerfilTableAcceso = (formUser: any, datosUsuarioCreado: any):UserOptions => {
  return {
    styles : { fontSize: 8 },
    columnStyles : { 0: {fillColor: '#13AD90', textColor: '#FFFFFF', halign: 'center', fontStyle: 'bold', lineWidth: 0.4, lineColor : '#F3F3F3', cellWidth: 35}},
    body: [
      [{content: 'Datos de acceso', colSpan: 2, styles: {halign: 'left', valign: 'middle', minCellHeight: 10, fillColor: '#FFFFFF', fontStyle: 'bold', textColor: '#000000'}}],
      ['Usuario', `${formUser.username || ''}`],
      ['Correo electrónico', `${formUser.email || ''}`],
      ['Contraseña temporal', `${datosUsuarioCreado?.code || ''}`],
    ],
  };
}

export const pdfPerfilTableSucursales = (bodyTableSucursales: any):UserOptions => {
  return {
    head: [
      [{content: 'Sucursales', colSpan: 2, styles: {halign: 'left',valign: 'middle',fillColor: '#FFFFFF', fontSize: 8, fontStyle: 'bold',textColor: '#000000'}}],
      ['Nombre de Sucursal', 'Dirección'],
    ],
    body: 
      (bodyTableSucursales.length > 0) 
      ? bodyTableSucursales 
      : Array([{content: 'Sin sucursales asignadas', colSpan: 2, styles: { halign: 'center', valign: 'middle' }}]),
    theme: 'grid',
    styles: {lineWidth: 0.4, lineColor: '#F3F3F3', overflow: 'linebreak', fontSize: 8},
  }; 
}

export const pdfPerfilTableDocumentos = (bodyTableDocumentos: any):UserOptions => {
  return {
    head: [
      [{content: 'Documentos', colSpan: 3, styles: {halign: 'left',valign: 'middle',fillColor: '#FFFFFF', fontSize: 8, fontStyle: 'bold',textColor: '#000000'}}],
      ['Nombre de sucursal', 'Documento', 'Serie'],
    ],
    body: 
      (bodyTableDocumentos.length > 0) 
      ? bodyTableDocumentos 
      : Array([{content: 'Sin documentos asignados', colSpan: 3, styles: { halign: 'center', valign: 'middle' }}]),
    theme: 'grid',
    styles: {lineWidth: 0.4, lineColor: '#F3F3F3', overflow: 'linebreak', fontSize: 8},
  };
}

export const pdfPerfilAddFooters = (pdf: jsPDF) => {
  const pageCount = pdf.internal.pages.filter((content:any) => content.length > 0).length;

  const addLogoFooters = (pageNumber: number) => {
    // Coloca el logo y footer en cada nueva página
    pdf.setPage(pageNumber);
    pdf.addImage(logoFeles, 'PNG', 10, 5, 6, 7); 
    pdf.setFont('helvetica', 'normal')
    // Paginacion
    pdf.setTextColor(128, 128, 128);
    pdf.setFontSize(10);
    pdf.text(`Páginas ${pageNumber} de ${pageCount}`, pdf.internal.pageSize.width - 50, pdf.internal.pageSize.height - 7);
    // Detalle de contacto y version
    pdf.setFontSize(7);
    pdf.setFont('helvetica', 'normal');
    pdf.text(`Ventas\n(+503) 22170270\nventas@itprofis-gt.com\nReparto Santa Leonor, prolongación 75 Av. Norte, Poligono G, #5, San Salvador`, 15, pdf.internal.pageSize.height -10);
    pdf.text(`Versión de formulario V0.0.9`, 15, pdf.internal.pageSize.height - 13);
  }

  for (let i = 1; i <= pageCount; i++) {
    addLogoFooters(i);
  }
}

export const pdfPerfilAddHeaders = (pdf: jsPDF, formClient: any, formUser: any, messageObjetive: boolean = true) => {
  // TITULO DE LA FICHA DEL CLIENTE
  pdf.setFont('helvetica', 'bold')
  pdf.setFontSize(14)
  pdf.text(`${formClient.nombre} - ${formUser.first_name} ${formUser.last_name}`, 15, 20)

  pdf.setFont('helvetica', 'normal');
  pdf.setTextColor(128, 128, 128);
  pdf.setFontSize(7);

  if (messageObjetive) {
    pdf.text(`
    Este formulario tiene como objetivo la creación de un usuario facturador en nuestro sistema. A continuación, se detallan los datos del usuario, 
    información de la empresa y sus sucursales. La información proporcionada será utilizada para registrar y gestionar la cuenta del facturador. 
    `, 195, 5, { align: 'right'});
  }
}

      